import { Button } from '@assembly-js/design-system';
import MUIDialogActions from '@mui/material/DialogActions';
import MUIDivider from '@mui/material/Divider';
import { FunctionComponent } from 'react';

import { DialogProps } from './types';

export interface DialogActionsProps extends Pick<DialogProps, 'actions'> {
  /** whether to show a divider between the actions */
  shouldShowDivider?: boolean;
}

/**
 * Actions component that can be used to display the actions of a dialog.
 * @param actions - the actions to display on the dialog
 * @param shouldShowDivider - whether to show a divider between the dialog contentand the actions.
 * @example
 * ```js
 * const actions = [
 *   { label: 'OK', onClick: () => {}},
 *   { label: 'Cancel', onClick: () => {}},
 * ];
 *
 * return (
 *   <DialogActions actions={actions} shouldShowDivider={false} />
 * );
 * ```
 */
export const DialogActions: FunctionComponent<DialogActionsProps> = ({
  actions = [],
  shouldShowDivider = true,
}) =>
  actions.length < 1 ? null : (
    <>
      {shouldShowDivider && <MUIDivider />}
      <MUIDialogActions className="!px-4 !py-3">
        {actions.map(({ className = '', ...action }) => (
          <Button
            className={`px-4 py-1 ml-2 ${className}`}
            key={action.label}
            {...action}
          />
        ))}
      </MUIDialogActions>
    </>
  );
